import { COOK } from './config';
import type { Difficulty } from './config';
import type { Doneness } from './types';

/* Pure cooking rules shared by the simulation, the UI and the tests. */

export interface CookTimes {
  golden: number;
  crispy: number;
  burnt: number;
  waffleReady: number;
  waffleBurnt: number;
  eggs: number;
  bacon: number;
}

export function cookTimes(difficulty: Pick<Difficulty, 'cookSlack'>): CookTimes {
  const s = difficulty.cookSlack;
  return {
    golden: COOK.hashBrowns.golden * s,
    crispy: COOK.hashBrowns.crispy * s,
    burnt: COOK.hashBrowns.burnt * s,
    // The iron always takes the same time to ding; only the burn window flexes.
    waffleReady: COOK.waffle.ready,
    waffleBurnt: COOK.waffle.ready + (COOK.waffle.burnt - COOK.waffle.ready) * s,
    eggs: COOK.eggs,
    bacon: COOK.bacon,
  };
}

export function hashBrownDoneness(seconds: number, t: CookTimes): Doneness {
  if (seconds >= t.burnt) return 'burnt';
  if (seconds >= t.crispy) return 'crispy';
  if (seconds >= t.golden) return 'golden';
  return 'raw';
}

/** 0 … 1 progress through the whole cook, for the colour ramp and rings. */
export function hashBrownProgress(seconds: number, t: CookTimes): number {
  return Math.max(0, Math.min(1, seconds / t.burnt));
}

export type WaffleStatus = 'cooking' | 'ready' | 'burnt';

export function waffleStatus(seconds: number, t: CookTimes): WaffleStatus {
  if (seconds >= t.waffleBurnt) return 'burnt';
  if (seconds >= t.waffleReady) return 'ready';
  return 'cooking';
}
